var React = require('react');

function Panels (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1 14C0.4 14 0 14.4 0 15V23C0 23.6 0.4 24 1 24H23C23.6 24 24 23.6 24 23V15C24 14.4 23.6 14 23 14H1Z","fill":"#181818","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1 0C0.4 0 0 0.4 0 1V9C0 9.6 0.4 10 1 10H23C23.6 10 24 9.6 24 9V1C24 0.4 23.6 0 23 0H1Z","fill":"#181818","key":1}),React.createElement("path",{"d":"M0 1C0 0.4 0.4 0 1 0H23C23.6 0 24 0.4 24 1V9C24 9.6 23.6 10 23 10H1C0.4 10 0 9.6 0 9V1Z","fill":"#181818","key":2}),React.createElement("path",{"d":"M0 15C0 14.4 0.4 14 1 14H23C23.6 14 24 14.4 24 15V23C24 23.6 23.6 24 23 24H1C0.4 24 0 23.6 0 23V15Z","fill":"#181818","key":3})]);
}

Panels.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Panels;

Panels.default = Panels;
